module.exports = __webpack_public_path__ + "img/Running.f7eff6ab.png";